import { ChannelSource } from './channel';
import { CustomerListItem } from './customer';
import { CustomerListActions, EventActions, EventData, NativeActions } from './event';

export enum ChatAssignTypes {
  MY = 1,
  COLL = 2,
  UNKNOWN = 3,
}
export type ChatAiStatus = 'open' | 'close';
export type ChatArchiveStatus = 'true' | 'false';

// 按分配
export interface ChatAssignCategory {
  type: 'ASSIGN';
  assignIndex: ChatAssignTypes;
}
// 按 AI 开启关闭
export interface ChatAiStatusCategory {
  type: 'AI';
  status: ChatAiStatus;
}
// 按渠道账号
export interface ChatSubSourceCategory {
  type: 'ACCOUNT';
  source: ChannelSource;
  subSourceId?: string;
}
export interface ChatArchiveCategory {
  type: 'ARCHIVE';
  status: ChatArchiveStatus;
}

export type SelectedChatCategory =
  | ChatAssignCategory
  | ChatAiStatusCategory
  | ChatSubSourceCategory
  | ChatArchiveCategory;

// 上传中
export type CustomMessageType = 'uploading';

/** 消息数据类型 */
export type MessageContentType =
  | 'text'
  | 'photo'
  | 'video'
  | 'note'
  | 'landing_page'
  | 'social_card'
  | 'lead_card'
  | 'tradeBusinessCard'
  | 'comment'
  | 'purchase_comments'
  | 'question_guide_msg_card'
  | 'retain_consult_card'
  | CustomMessageType;

/** 消息来源类型：访客 | 客服 | AI */
export type MessageFromType = 'customer' | 'agent' | 'ai';
/** 消息类型：普通消息 | 系统消息 | 评论 | 事件 | 自动化 */
export type MessageType = 'message' | 'system' | 'comment' | 'event' | 'automation';

/** 标记 */
export enum CustomerSign {
  NO_REPLY = 1,
}

/** 消息状态 */
export enum MessageStatus {
  SUCCEED = 1,
  FAILED = 2,
}

export interface Size {
  width: number;
  height: number;
}

/** 图片消息 */
export interface PhotoContent {
  link: string;
  size: Size;
}
/** 视频消息 */
export interface VideoContent {
  link: string;
  cover: string;
  duration: number;
  videoSize: number;
  size: Size;
}
/** 笔记消息 */
export interface CardNoteContent {
  id: string;
  title: string;
  cover: string;
  link: string;
  userInfo: {
    nickname: string;
    avatar: string;
  };
}
/** 落地页消息 */
export interface CardLandingPageContent {
  id: string;
  title: string;
  cover: string;
  link: string;
  desc: string;
}
/** 名片卡 */
export interface CardSocialContent {
  id: string;
  title: string;
  name: string;
  cover: string;
  cardType?: number;
}
/** 留资卡 */
export interface CardLeadContent {
  id: string;
  title: string;
  name: string;
  cover: string;
}
/** 交易卡 */
export interface CardTradeBusinessContent {
  id: string;
  title: string;
  cover: string;
  subTitle: string;
  linkPlatform: string;
}
/** 意向评论回复 */
export interface CommentContent {
  subjectId: string;
  subjectCover: string;
  subjectTitle: string;
  subjectLink: string;
  commentContent: string;
  commentTime: number;
  commentId: string;
}
/** 意向评论回复 */
export interface PurchaseCommentsContent {
  commentId: string;
  commentTitle: string;
  commentContent: string;
  content: string;
}

/** 问题引导卡 */
export interface CardQuestionGuideMsgContent {
  title: string;
  cardId: string;
  questions: string[];
}

/** 抖音留资卡 */
export interface CardRetainConsultContent {
  title: string;
  cardId: string;
  mediaId?: string;
  coverUrl: string;
  components: number[];
}

export interface UploadingContent {
  filename: string;
  contentType: 'photo' | 'video';
}

export type MessageData = EventData<
  'MESSAGE',
  {
    id: string;
    sendAt: number;
    agentId: number;
    type: MessageType;
    fromType: MessageFromType;
    contentType: MessageContentType;
    content: string;
    customerId: string;
    entId: string;
    customerInfo: CustomerListItem;
    repliedMsgId?: string;
  }
>;

export type HintData = EventData<NativeActions, any>;

export type CustomerListEventData = EventData<CustomerListActions, CustomerListItem>;

export type Feedback = 'upvote' | 'downvote' | undefined;

export interface BaseMesssgeProps {
  id: string;
  sendAt: number;
  agentId: number;
  type: MessageType;
  content: string;
  opAgentName?: string;
}

export interface MessageItem extends BaseMesssgeProps {
  fromType: MessageFromType;
  contentType: MessageContentType;
  feedback?: Feedback;
  status?: MessageStatus;
  withdraw?: boolean;
  hasReply?: boolean;
  repliedMsgId?: string;
}

export interface EventItem extends BaseMesssgeProps {
  contentType: EventActions;
}

export type StreamItem = MessageItem | EventItem;

export type MessageRenderProps<T = string, U = object> = U & {
  env: 'chat' | 'preview';
  content: T;
};

export type MessageRenderType = 'send' | 'receive';

export interface CustomerCount {
  colleagueCount: number;
  myCount: number;
  unassignedCount: number;
  sourceCount: Record<ChannelSource, number>;
  subSourceCount: Record<string, number>;
  enableAiCount: { true: number; false: number };
  archiveCount: { true: number; false: number };
}
